import { v4 as uuidv4 } from "uuid";
import checkBulletImage from "@circle-react-shared/BuilderUI/Assets/icons/check_bullet.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createBlockquoteBlock,
  createH2Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import {
  getFontSizeOptions,
  getFontWeightOptions,
  getLineHeightOptions,
} from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { primaryBlockDefaultStyles } from "../../constants";
import placeholderImage from "./homepage_block_4_default_image.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HomepageBlock4",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Strategic mentorship that moves you forward",
        }),
        createPBlock({
          text: "At Growth Network, expert guidance is built into the process. Get support from seasoned strategists who help you shape, scale, and sustain programs with purpose.",
        }),
      ],
    },
    leftContent: {
      prop: "children",
      type: "children",
      value: [
        createBlockquoteBlock({
          text: "“Our work is about building confidence, and real momentum. Inside Elevate, you’ll find expert support, smart frameworks, and a community that helps you grow a teaching business that truly reflects your purpose”",
          styles: {
            fontWeight: getFontWeightOptions("600"),
            fontSize: getFontSizeOptions("1.25rem"),
            lineHeight: getLineHeightOptions("1.5"),
          },
        }),
        createPBlock({
          text: "At Growth Network, guidance goes beyond instruction. Our mentors are seasoned strategists—backed by real experience—who help professionals turn expertise into scalable, high-impact programs. Drawing from learning design, solopreneur systems, and evidence-based practice, our approach gives you the tools to build lasting programs, thoughtful infrastructure, and content that connects.",
          paragraphStyle: "p3",
        }),
        createUlBlock({
          items: [
            {
              text: "15+ years of curriculum development expertise",
              placeholder: checkBulletImage,
            },
            {
              text: "300+ professionals launched through structured mentorship",
              placeholder: checkBulletImage,
            },
            {
              text: "Systems that support both sustainable growth and personal vision",
              placeholder: checkBulletImage,
            },
            {
              text: "A clear path from expert to community-driven leader",
              placeholder: checkBulletImage,
            },
          ],
        }),
      ],
    },
    rightContent: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: placeholderImage,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                maxHeight: "none",
                maxWidth: "none",
                width: "100%",
                height: "100%",
                minHeight: "auto",
                minWidth: "auto",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: primaryBlockDefaultStyles.backgroundColor,
        }),
        padding: getPaddingOptions({
          defaultValue: primaryBlockDefaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: primaryBlockDefaultStyles.margin,
        }),
      },
    },
  },
};
